import { render, staticRenderFns } from "./CourseRooms.vue?vue&type=template&id=676cc75e&"
import script from "./CourseRooms.vue?vue&type=script&lang=js&"
export * from "./CourseRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports